import { useMemo } from "react";
import { cleanStory } from "../lib/sanitize";

export const StoryHtml = ({ html, style, testId }) => {
  const markup = useMemo(() => ({ __html: cleanStory(html) }), [html]);
  return <div className="story" style={style} data-testid={testId} dangerouslySetInnerHTML={markup} />;
};
